import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/** clsx + tailwind-merge による className ユーティリティ */
export const cn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs));
};
